// Extra functions not specific to one area




// format dates to be dd/mm/yyyy and remove time if present
window.formatDate = function formatDate(inputDate) {
    if (inputDate.includes('T')) {
        inputDate = inputDate.split('T')[0];
    }
    const [year, month, day] = inputDate.split('-');
    return `${day}/${month}/${year}`;
}

// This script is used to fetch all orders for a customer from dotApparel
window.dotApparel = async function dotApparel(endpoint, options = {}) {
    const defaultHeaders = {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Content-Type": "application/json",
        ...options.headers,
    };

    const config = {
        method: options.method || "GET",
        headers: defaultHeaders,
        body: options.body && typeof options.body === "object"
            ? JSON.stringify(options.body)
            : options.body,
    };

    const response = await fetch(`/apps/dotapparel/${endpoint}`, config);

    if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        console.error("Request failed:", errorData || response.statusText);
        throw new Error(errorData?.message || `HTTP error! Status: ${response.status}`);
    }

    return response.json();
};

// Checks if store us AU or NZ
window.isNZ = function isNZ() {
    const currentDomain = window.location.hostname;
    return currentDomain.includes('.nz') ? true : false;
}

window.storeFrontAccessToken = function storeFrontAccessToken() {
    return isNZ() ? 'e8685c940a51ba7a8265255970ed4644' : '772ec50dbdef4fc725d38d40c8f8cbfc'
}

window.storeFrontInstance = async function storeFrontInstance(endpoint, options = {}) {

    const defaultHeaders = {
        "Content-Type": "application/graphql",
        "X-Shopify-Storefront-Access-Token": storeFrontAccessToken(),
        ...options.headers,
    };

    const config = {
        method: options.method || 'POST',
        headers: defaultHeaders,
        body: options.body || null,
    };

    const response = await fetch(`https://${Shopify.shop}/${endpoint}`, config);

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
};

window.requestHandler = function requestHandler(promise) {
    return promise
        .then((data) => [data, undefined])
        .catch((error) => Promise.resolve([undefined, error]));
};

window.redirectTo = function redirectTo(url, identifier) {
    if (identifier) {
        identifier.appendChild(
            Object.assign(document.createElement("input"), {
                type: "hidden",
                name: "return_to",
                value: url,
            })
        );
    }
}
